import styled from 'styled-components';
import SecondaryButton from '@carvana/showroom-forms/Button/Secondary';

export const SevenDayGuaranteeCardWrapper = styled.div`
  max-width: 912px;
  background: #ffffff;
  border: 1px solid #d9dde9;
  box-sizing: border-box;
  box-shadow: 0px 2px 3px rgba(24, 53, 88, 0.1);
  border-radius: 8px;
  margin: 0 auto;
  overflow: hidden;
`;

export const ProgressBarAndBadgeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 8px;
  margin-bottom: 32px;
  min-height: 169px;
  // For tablet and desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    margin-bottom: 16px;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  // For desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    flex-direction: row;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 16px;

  // For desktop - devices greater than 768px
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    margin-bottom: 0;
    min-height: 56px;
  }
`;

export const Button = styled(SecondaryButton)`
  margin: 0;
  min-height: 40px;
  word-break: break-word;
  padding: 0 24px;
  align-self: flex-end;
  width: 100%;
  text-transform: uppercase;
  min-width: auto !important;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    min-width: 200px !important;
    max-width: 200px;
  }
`;

export const BoldTitle = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    margin-right: 34px;
  }
`;

export const InfoText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--cvna-color-grey-5);
  margin-bottom: 8px;
`;

export const BoldText = styled.h3`
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: var(--cvna-color-blue-6);
  display: inline;
`;

export const AdditionalInfoText = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--cvna-color-grey-5);
  margin-bottom: 8px;
`;

export const CustomLink = styled.button`
  text-decoration: underline;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--cvna-color-blue-2);
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }
`;
